import { react2angular } from 'react2angular'
import IntercomCssBaseline from '@worldfavor/components/IntercomCssBaseline'

export default react2angular(IntercomCssBaseline, [])
